import { Button } from '@material-ui/core';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

function DeleteActionRender({
  cellInfo,
  setDeletePopup,
  setDeleteData,
  disabled,
}) {
  return (
    <div className="tdCell icon-btn-group">
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="delete-tooltip">Delete</Tooltip>}
      >
        <Button
          data-testid="deleteBtn"
          className="th-ic trash-blue"
          variant="text"
          type="button"
          disabled={disabled}
          onClick={() => {
            setDeleteData(cellInfo);
            setDeletePopup(true);
          }}
          aria-label="Delete"
        >
          <SVGComponent iconName="Icon-delete" />
        </Button>
      </OverlayTrigger>
    </div>
  );
}

export default DeleteActionRender;
